import "./subheading.scss";

export default function Subheading({ children }) {
  return (
    <h2 className="subheading">
      <span>{children}</span>
    </h2>
  );
}
